<template>
  <div class="breadcrumb" id="breadcrumb-id">
    <div class="color-line1"></div>
    <div class="color-line2"></div>
    <div
      class="breadcrumb-content"
      v-for="(item, index) in routeList"
      :key="item.label + index"
      @click="toPath(item)"
    >
      <img v-if="item.iconPath" :src="require(`@/assets${item.iconPath}`)" />
      <span :class="pathName === item.path ? 'current' : 'default'">{{
        item.label
      }}</span>
      <span v-if="index !== routeList.length - 1" class="next">></span>
    </div>
  </div>
</template>
<script>
/**
 * @interface routeItem{
 * @param {string} label required
 * @param {string} path required
 * @param {object} query optional
 * @param {string} iconPath optional  示例：从@/assets后面路径开始 如：/image/mbx-icon.png
 * }
 * @param {Array<routeItem>} list required
 * @param {string : push | replace } type optional
 *
 */
export default {
  name: 'Breadcrumb',
  props: ['list', 'type'],
  data() {
    const urlArr = window.location.pathname.split('/')
    let pathName = ''
    if (urlArr.length > 0) {
      pathName = '/' + urlArr[urlArr.length - 1]
    }
    return {
      routeList: [
        {
          label: '首页',
          path: '/',
          iconPath: '/image/mbx-icon.png'
        }
      ].concat(this.list),
      pathName,
      routerType: this.type ?? 'push'
    }
  },
  mounted() {
    let width = 20
    document.querySelectorAll('.breadcrumb-content').forEach(item => {
      width += item.offsetWidth
    })
    document.querySelector('.color-line2').style.width = width + 'px'
  },
  methods: {
    toPath(item) {
      const { path = '/', query = {} } = item
      if (this.pathName === path) return
      this.$router[this.routerType]({
        path,
        query
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.breadcrumb {
  box-sizing: border-box;
  max-width: 1300px;
  height: 54px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: linear-gradient(0deg, #ffffff 0%, #eaeaea 100%);
  position: relative;
  .color-line1 {
    position: absolute;
    box-sizing: border-box;
    width: calc(100% - 36px);
    height: 2px;
    background: rgba($color: #085dc8, $alpha: 0.35);
    top: 0;
    left: 0;
    margin: 0 18px;
  }
  .color-line2 {
    position: absolute;
    width: 128px;
    height: 4px;
    background: #ff4e4e;
    top: 0;
    left: 18px;
  }
  .breadcrumb-content {
    height: 100%;
    line-height: 54px;
    cursor: pointer;
    > img {
      vertical-align: middle;
      margin-right: 10px;
      width: 24px;
      height: 24px;
    }
    .default {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }
    .current {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0853b6;
    }
    .next {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      margin: 0 12px;
    }
  }
}
</style>
